import {BaseRouteMetaDataModel} from "../../../infrastructure/models/route/base-route.meta-data.model";

export class CalculatorRouteMetaDataModel extends BaseRouteMetaDataModel {
  get pageTitle() {
    return 'calculator title';
  }

  get description() {
    return 'calculator description'
  }
}